import { ArrowRight } from "lucide-react";

const STATS = [
  { value: "2011", label: "ESTABLISHED" },
  { value: "4", label: "REGIONS" },
  { value: "50+", label: "INSTITUTIONAL ENGAGEMENTS" },
];

export const Enterprise = () => (
  <section id="group" className="bg-[#F5F5F0] text-[#111111] px-6 lg:px-12 py-24 lg:py-32" data-testid="enterprise-section">
    <div className="grid lg:grid-cols-2 gap-16">
      <div>
        <p className="font-mono text-xs tracking-[0.35em] text-black/50 flex items-center gap-4">
          THE ENTERPRISE <span className="inline-block w-16 h-px bg-black/30" />
        </p>
        <h2 className="mt-8 font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.1] tracking-tight" data-testid="enterprise-headline">
          Technology for the institutions that shape the world.
        </h2>
      </div>
      <div className="flex flex-col justify-between gap-12">
        <p className="text-base sm:text-lg leading-relaxed text-black/70 max-w-xl" data-testid="enterprise-about">
          A-Square Group is a governance technology and intelligence enterprise
          developing systems, infrastructure and institutional capabilities for
          governments, public agencies and critical environments.
        </p>
        <a
          href="#intelligence"
          data-testid="enterprise-about-link"
          className="inline-flex items-center gap-3 font-mono text-xs tracking-[0.3em] border-b border-black/30 pb-3 w-fit hover:border-black hover:gap-5 transition-all duration-300"
        >
          ABOUT A-SQUARE GROUP <ArrowRight className="w-4 h-4" />
        </a>
        <div className="grid grid-cols-3 gap-8 border-t border-black/15 pt-8" data-testid="enterprise-stats">
          {STATS.map((s) => (
            <div key={s.label}>
              <p className="font-display text-4xl lg:text-5xl">{s.value}</p>
              <p className="mt-2 font-mono text-[10px] tracking-[0.25em] text-black/50">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);
